import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import { saveAs } from 'file-saver';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const Rendercscbundle = () => {
//const forceUpdate = Rendercscbundle();
const resturl=sessionStorage.getItem("RESTURL");
const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


//let alltablerows=null;

const [modal, setModal] = useState({open:false});
const [rerenderrows, setRerenderrows] = useState({done:false});
const navWpform = React.useRef();
const [tablerows, setTablerows] = useState([]);

const [tblcardprintdate, setTblcardprintdate] = useState([]);


const [combolocation, setCombolocation] = useState([]);


const [dowait, setDowait] = useState({on:false});


const [crit, setCrit] = useState({
YRMM:''
});

const [app, setApp] = useState({
age:''
, fname:''
, lname:''
});



const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

	setupTablerows();
 },[]);



useEffect(() => {
 
console.log("app: "+JSON.stringify(app));
if (rerenderrows.done==false)
	setupTablerows();
/*

if (app.lname)
	if (app.lname!="")
		forceUpdate();

let temp=tablerows;
setTablerows([]);
setTablerows(temp);
*/

},[app]);


useEffect(() => {

setRerenderrows({done:tablerows.length>0});

},[JSON.stringify(tablerows)]);


async function vwcardprintdate(e){

if (e)
	e.target.classList.add("hidden");

const params={
	cardprintdate:document.getElementsByName("cardprintdate")[0].value
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setTblcardprintdate([]);
await  fetch(customspremurl+'rarmssql/view_card_print_date',requestOptions)
      .then(res => res.json())
      .then(res => 	aftervwcardprintdate(res) )
      .catch(err => console.log(err));

}//end func


function aftervwcardprintdate(res){

let temp=[];

	res.map((col, index) => {
		//const WORK_PERMIT_ID=col['WORK_PERMIT_ID'];
		
		const key="cardprint_"+index;
		temp.push(
			<tr key={key} >
			<td align="right" >{index+1}</td>
			<td align="left" >{col['work_permit_id']}</td>
			<td align="center" >{col['work_permit_no']}</td>
			<td align="center" >{col['dob']}</td>
			<td align="left" >{col['full_name']}</td>
			<td align="center" >{col['card_print_date']}</td>
			<td align="left" >{col['employer']}</td>
			</tr>
			);
		});//end map

setTblcardprintdate(temp);
/*
<th>work pmt id #</th>
<th>img ref #</th>
<th>dob</th>
<th>applicant</th>
<th>card print date</th>

*/	
}//end func


async function setupTablerows(){
/*
2025-06-28
this method must be called in useEffect of app 
otherwise it will not display the updated values of app.fname and app.lname
*/
let temprows=[];
console.log("setupTablerows: ");
//const temp=app;

temprows.push(<tr key="row2" >
			<td align="right">first name:</td>
			<td align="left"><input name="fname" value={app.fname} onChange={(e)=>{handleChange(e);}} autoComplete="off" /></td>
		</tr>);
		
temprows.push(<tr key="row3" >
			<td align="right">last name:</td>
			<td align="left"><input name="lname" value={app.lname} onChange={(e)=>{handleChange(e);}} autoComplete="off"  /></td>
		</tr>);

setTablerows(temprows);

}//end func





function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func


async function getxlfilename(e, flag){
	e.preventDefault();
	
/*
	if (crit.YRMM=="" && flag!="ytdsummary"){
		showsnackbar("click a month first");
		return;
		}

	if (crit.decorcmp_name.trim().length<4 && flag=="outstandbol"){
		showsnackbar("enter part of the BOL consignee name first");
		return;
		}
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };	
  
  await  fetch(resturl+'rarawxlreport/getxlfilename',requestOptions)
      .then(res => res.json())
      .then(res => 	{
		  if (flag=="ytdsummary")
			  rptYtdsummary(res);
		  
		  
	  }  )
      .catch(err => console.log(err));
*/
	  
}//end func

async function rptYtdsummary(res){
	
let FILE_NAME="default_file_name";
if (res.length)
	FILE_NAME="CUSTOMS_REVENUE_SIGTAS_"+res[0].FILE_NAME;


const params={
	username:sessionStorage.getItem("USERNAME")
	, currdate:crit.YRMM==''?'':crit.YRMM+"-01"
, filename:FILE_NAME 
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

document.getElementById("btnexcel3").style.visibility="hidden";

await  fetch(resturl+'rarawxlreport/rptytdsummryxl',requestOptions)
      .then(res => 	afterrptytdsummary(res, FILE_NAME) )
      .catch(err => console.log(err));

}//end func
	
async function afterrptytdsummary(res, FILE_NAME){
	document.getElementById("btnexcel3").style.visibility="visible";
		const pBlob = await res.blob();
	var blob = new Blob([pBlob], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
saveAs(blob, FILE_NAME+".xlsx");

}//end func


function handleChange(e){

const {name, value} = e.target;


setApp((prev)=>{
	return {...prev, [name]:value}
	});
	
}//end func


function writeApp(e){
	
	setRerenderrows({done:false});
	
	setApp({
age:'48'
, fname:'kim'
, lname:'jones'
});
	
}





const yesnooptions = <>
		<option value="0" >No</option>
		<option value="1" >Yes</option>
		</>;
	
	
  return (
    <>
	<table align='center' style={{marginTop:"10px", marginBottom:"10px"}}>
	<tbody>
	<tr key="row1" >
		<td align="right">age:</td>
		<td align="left"><input name="age" value={app.age} onChange={(e)=>{handleChange(e);}} autoComplete="off" /></td>
	</tr>
	{tablerows}
	</tbody>
	</table>	
<div align='center' ><button onClick={(e)=>{writeApp(e);}} >write app</button></div>
	
	{
		"ajones"==sessionStorage.getItem("USERNAME") && <>
			<div align='center'>
			<input type="date" name="cardprintdate"  onChange={(e)=>{document.getElementById("btnvwcardprintdate").classList.remove("hidden");}} />
			<button onClick={(e)=>{vwcardprintdate(e);}} className="button hidden" id="btnvwcardprintdate"  >get view card print</button>
			<table align="center" border="1" style={{borderCollapse:"collapse"}} >
			<thead>
				<tr>
					<th>#</th>
					<th>work pmt id #</th>
					<th>img ref #</th>
					<th>dob</th>
					<th>applicant</th>
					<th>card print date</th>
					<th>employer</th>
				</tr>
			</thead>
			<tbody>
				{tblcardprintdate}
			</tbody>
			</table>
			</div>

 <div align="center" style={{marginTop:"18px"}} >
 <a href="#" className="nodecor" id="btnexcel3" onClick={(e)=>{getxlfilename(e, 'ytdsummary');}} ><img src="img/msexcel.gif" border="0" /> Year to Date Treasury Revenue</a>
 </div> 
</>

	}





<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default Rendercscbundle;